// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KpisTCU_card__Pd9m6 {
  min-height: 60px;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 8px 12px;
  border: 1px solid #c6d9df;
  border-radius: 10px;
  background: #cddaea;
  overflow: hidden;
  box-sizing: border-box;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 1px 3px rgba(16, 24, 40, 0.06);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.KpisTCU_card__Pd9m6:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 12px rgba(16, 24, 40, 0.08);
}

/* LEFT CONTENT */

.KpisTCU_cardContent__MQGHP {
  min-width: 0;
  flex: 1 1;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  height: 44px;
}

/* LABEL */

.KpisTCU_labelRow__nP3TU {
  display: flex;
  align-items: center;

  gap: 5px;

  min-width: 0;

  line-height: 1;
}

.KpisTCU_label__yZ8Gj {
  font-size: 0.68rem;
  font-weight: 600;

  letter-spacing: 0.04em;
  text-transform: uppercase;

  color: #6b7280;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* DOWNLOAD */

.KpisTCU_downloadIcon__YKxXT {
  flex-shrink: 0;

  color: #6b7280;

  cursor: pointer;
}

.KpisTCU_downloadIcon__YKxXT:hover {
  color: #022352;
}

/* VALUE */

.KpisTCU_value__7MFbj {
  margin-top: 6px;
  margin-right: auto;
  font-size: 1.35rem;
  font-weight: 800;
  line-height: 1;
  color: #022352;
  white-space: nowrap;
}

/* ICON */

.KpisTCU_iconWrapper__1Dv5y {
  width: 48px;
  height: 44px;

  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;
}

.KpisTCU_icon__Yt8k6 {
  width: 36px;
  height: 36px;

  color: #4b71a2;
}

/* TALL CARD WITH BUCKETS */

.KpisTCU_cardTall__TDJ4D {
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  gap: 6px;
}

.KpisTCU_topRow__OuqcC {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  height: 44px;
}

.KpisTCU_topRowCompact__Ss-pg {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.KpisTCU_iconSmall__4lvZn {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  color: #4b71a2;
}

.KpisTCU_bucketRow__z3jCt {
  flex: 1 1;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

/* BUCKET: value on top, name + download on one line below */

.KpisTCU_bucket__LMUeR {
  /* buckets share the row equally and wrap to a new line instead of squeezing */
  flex: 1 1 68px;
  min-width: 0;

  display: flex;
  align-items: center;

  padding: 8px 10px;
  border: 1px solid #a9bfd4;
  border-radius: 10px;
  background: #e8f0f7;
  cursor: pointer;
}

/* bucket currently applied as the page filter */

.KpisTCU_bucketSelected__UIONT {
  border-color: #6f93c2;
  background: #83a4cf;
  box-shadow: 0 1px 4px rgba(2, 35, 82, 0.15);
}

.KpisTCU_bucketSelected__UIONT .KpisTCU_bucketName__r346t {
  color: #022352;
}

/* chip in the card header: shows the applied bucket, click to remove it */

.KpisTCU_bucketClearBtn__LWLiM {
  flex-shrink: 0;

  display: inline-flex;
  align-items: center;
  gap: 3px;

  padding: 2px 6px;
  border: 1px solid #022352;
  border-radius: 10px;
  background: #ffffff;

  font-size: 0.62rem;
  font-weight: 600;
  line-height: 1;
  color: #022352;
  cursor: pointer;
}

.KpisTCU_bucketClearBtn__LWLiM:hover {
  background: #022352;
  color: #ffffff;
}

.KpisTCU_bucketText__sw-gu {
  flex: 1 1;
  min-width: 0;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.KpisTCU_bucketValue__QzJIh {
  font-size: clamp(0.95rem, 1.3vw, 1.2rem);
  font-weight: 800;
  line-height: 1.1;
  color: #022352;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.KpisTCU_bucketFooter__W2hvy {
  margin-top: 3px;
  min-width: 0;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.KpisTCU_bucketName__r346t {
  min-width: 0;
  font-size: 0.66rem;
  font-weight: 600;
  line-height: 1.1;
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* HEALTH VARIANTS: same box, colored dot + value */

.KpisTCU_bucketHealthy__b7x8h .KpisTCU_bucketName__r346t::before,
.KpisTCU_bucketUnhealthy__WB8TM .KpisTCU_bucketName__r346t::before {
  content: '';
  display: inline-block;
  width: 6px;
  height: 6px;
  margin-right: 4px;
  border-radius: 50%;
  vertical-align: 0;
}

.KpisTCU_bucketHealthy__b7x8h .KpisTCU_bucketName__r346t::before {
  background: #16a34a;
}

.KpisTCU_bucketUnhealthy__WB8TM .KpisTCU_bucketName__r346t::before {
  background: #dc2626;
}

.KpisTCU_bucketHealthy__b7x8h .KpisTCU_bucketValue__QzJIh {
  color: #15803d;
}

.KpisTCU_bucketUnhealthy__WB8TM .KpisTCU_bucketValue__QzJIh {
  color: #b91c1c;
}

/* TABLET */

@media (max-width: 991.98px) {
  .KpisTCU_card__Pd9m6 {
    padding: 8px 10px;
  }

  .KpisTCU_label__yZ8Gj {
    font-size: 0.65rem;
  }

  .KpisTCU_value__7MFbj {
    font-size: 1.25rem;
  }

  .KpisTCU_iconWrapper__1Dv5y {
    width: 44px;
  }

  .KpisTCU_icon__Yt8k6 {
    width: 32px;
    height: 32px;
  }
}

/* MOBILE */

@media (max-width: 575.98px) {
  .KpisTCU_card__Pd9m6 {
    padding: 8px 9px;
  }

  .KpisTCU_label__yZ8Gj {
    font-size: 0.62rem;
  }

  .KpisTCU_value__7MFbj {
    font-size: 1.2rem;
  }

  .KpisTCU_iconWrapper__1Dv5y {
    width: 42px;
  }

  .KpisTCU_icon__Yt8k6 {
    width: 30px;
    height: 30px;
  }

  .KpisTCU_bucket__LMUeR {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(25% - 8px);
    padding: 6px 8px;
  }

  .KpisTCU_bucketValue__QzJIh {
    font-size: 1.05rem;
  }

  .KpisTCU_bucketName__r346t {
    font-size: 0.6rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/SmartCIty/TCU/DeviceHealth/Kpis/KpisTCU.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,8EAA8E;EAC9E,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,iBAAiB;;AAEjB;EACE,YAAY;EACZ,SAAO;;EAEP,aAAa;EACb,sBAAsB;EACtB,2BAA2B;;EAE3B,YAAY;AACd;;AAEA,UAAU;;AAEV;EACE,aAAa;EACb,mBAAmB;;EAEnB,QAAQ;;EAER,YAAY;;EAEZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;;EAEhB,sBAAsB;EACtB,yBAAyB;;EAEzB,cAAc;;EAEd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,aAAa;;AAEb;EACE,cAAc;;EAEd,cAAc;;EAEd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,UAAU;;AAEV;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA,SAAS;;AAET;EACE,WAAW;EACX,YAAY;;EAEZ,cAAc;;EAEd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,cAAc;AAChB;;AAEA,2BAA2B;;AAE3B;EACE,sBAAsB;EACtB,oBAAoB;EACpB,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA,4DAA4D;;AAE5D;EACE,8EAA8E;EAC9E,cAAc;EACd,YAAY;;EAEZ,aAAa;EACb,mBAAmB;;EAEnB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,gDAAgD;;AAEhD;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA,0EAA0E;;AAE1E;EACE,cAAc;;EAEd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;;EAER,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;;EAEnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;;EAEZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,mDAAmD;;AAEnD;;EAEE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,WAAW;;AAEX;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,WAAW;;AAEX;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".card {\n  min-height: 60px;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 8px 12px;\n  border: 1px solid #c6d9df;\n  border-radius: 10px;\n  background: #cddaea;\n  overflow: hidden;\n  box-sizing: border-box;\n  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 1px 3px rgba(16, 24, 40, 0.06);\n  transition: transform 0.18s ease, box-shadow 0.18s ease;\n}\n\n.card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 12px rgba(16, 24, 40, 0.08);\n}\n\n/* LEFT CONTENT */\n\n.cardContent {\n  min-width: 0;\n  flex: 1;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n\n  height: 44px;\n}\n\n/* LABEL */\n\n.labelRow {\n  display: flex;\n  align-items: center;\n\n  gap: 5px;\n\n  min-width: 0;\n\n  line-height: 1;\n}\n\n.label {\n  font-size: 0.68rem;\n  font-weight: 600;\n\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n\n  color: #6b7280;\n\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* DOWNLOAD */\n\n.downloadIcon {\n  flex-shrink: 0;\n\n  color: #6b7280;\n\n  cursor: pointer;\n}\n\n.downloadIcon:hover {\n  color: #022352;\n}\n\n/* VALUE */\n\n.value {\n  margin-top: 6px;\n  margin-right: auto;\n  font-size: 1.35rem;\n  font-weight: 800;\n  line-height: 1;\n  color: #022352;\n  white-space: nowrap;\n}\n\n/* ICON */\n\n.iconWrapper {\n  width: 48px;\n  height: 44px;\n\n  flex-shrink: 0;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon {\n  width: 36px;\n  height: 36px;\n\n  color: #4b71a2;\n}\n\n/* TALL CARD WITH BUCKETS */\n\n.cardTall {\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: flex-start;\n  gap: 6px;\n}\n\n.topRow {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  height: 44px;\n}\n\n.topRowCompact {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 6px;\n}\n\n.iconSmall {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n  color: #4b71a2;\n}\n\n.bucketRow {\n  flex: 1;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n/* BUCKET: value on top, name + download on one line below */\n\n.bucket {\n  /* buckets share the row equally and wrap to a new line instead of squeezing */\n  flex: 1 1 68px;\n  min-width: 0;\n\n  display: flex;\n  align-items: center;\n\n  padding: 8px 10px;\n  border: 1px solid #a9bfd4;\n  border-radius: 10px;\n  background: #e8f0f7;\n  cursor: pointer;\n}\n\n/* bucket currently applied as the page filter */\n\n.bucketSelected {\n  border-color: #6f93c2;\n  background: #83a4cf;\n  box-shadow: 0 1px 4px rgba(2, 35, 82, 0.15);\n}\n\n.bucketSelected .bucketName {\n  color: #022352;\n}\n\n/* chip in the card header: shows the applied bucket, click to remove it */\n\n.bucketClearBtn {\n  flex-shrink: 0;\n\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n\n  padding: 2px 6px;\n  border: 1px solid #022352;\n  border-radius: 10px;\n  background: #ffffff;\n\n  font-size: 0.62rem;\n  font-weight: 600;\n  line-height: 1;\n  color: #022352;\n  cursor: pointer;\n}\n\n.bucketClearBtn:hover {\n  background: #022352;\n  color: #ffffff;\n}\n\n.bucketText {\n  flex: 1;\n  min-width: 0;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n\n.bucketValue {\n  font-size: clamp(0.95rem, 1.3vw, 1.2rem);\n  font-weight: 800;\n  line-height: 1.1;\n  color: #022352;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n}\n\n.bucketFooter {\n  margin-top: 3px;\n  min-width: 0;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n}\n\n.bucketName {\n  min-width: 0;\n  font-size: 0.66rem;\n  font-weight: 600;\n  line-height: 1.1;\n  color: #6b7280;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* HEALTH VARIANTS: same box, colored dot + value */\n\n.bucketHealthy .bucketName::before,\n.bucketUnhealthy .bucketName::before {\n  content: '';\n  display: inline-block;\n  width: 6px;\n  height: 6px;\n  margin-right: 4px;\n  border-radius: 50%;\n  vertical-align: 0;\n}\n\n.bucketHealthy .bucketName::before {\n  background: #16a34a;\n}\n\n.bucketUnhealthy .bucketName::before {\n  background: #dc2626;\n}\n\n.bucketHealthy .bucketValue {\n  color: #15803d;\n}\n\n.bucketUnhealthy .bucketValue {\n  color: #b91c1c;\n}\n\n/* TABLET */\n\n@media (max-width: 991.98px) {\n  .card {\n    padding: 8px 10px;\n  }\n\n  .label {\n    font-size: 0.65rem;\n  }\n\n  .value {\n    font-size: 1.25rem;\n  }\n\n  .iconWrapper {\n    width: 44px;\n  }\n\n  .icon {\n    width: 32px;\n    height: 32px;\n  }\n}\n\n/* MOBILE */\n\n@media (max-width: 575.98px) {\n  .card {\n    padding: 8px 9px;\n  }\n\n  .label {\n    font-size: 0.62rem;\n  }\n\n  .value {\n    font-size: 1.2rem;\n  }\n\n  .iconWrapper {\n    width: 42px;\n  }\n\n  .icon {\n    width: 30px;\n    height: 30px;\n  }\n\n  .bucket {\n    flex: 1 1 calc(25% - 8px);\n    padding: 6px 8px;\n  }\n\n  .bucketValue {\n    font-size: 1.05rem;\n  }\n\n  .bucketName {\n    font-size: 0.6rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `KpisTCU_card__Pd9m6`,
	"cardContent": `KpisTCU_cardContent__MQGHP`,
	"labelRow": `KpisTCU_labelRow__nP3TU`,
	"label": `KpisTCU_label__yZ8Gj`,
	"downloadIcon": `KpisTCU_downloadIcon__YKxXT`,
	"value": `KpisTCU_value__7MFbj`,
	"iconWrapper": `KpisTCU_iconWrapper__1Dv5y`,
	"icon": `KpisTCU_icon__Yt8k6`,
	"cardTall": `KpisTCU_cardTall__TDJ4D`,
	"topRow": `KpisTCU_topRow__OuqcC`,
	"topRowCompact": `KpisTCU_topRowCompact__Ss-pg`,
	"iconSmall": `KpisTCU_iconSmall__4lvZn`,
	"bucketRow": `KpisTCU_bucketRow__z3jCt`,
	"bucket": `KpisTCU_bucket__LMUeR`,
	"bucketSelected": `KpisTCU_bucketSelected__UIONT`,
	"bucketName": `KpisTCU_bucketName__r346t`,
	"bucketClearBtn": `KpisTCU_bucketClearBtn__LWLiM`,
	"bucketText": `KpisTCU_bucketText__sw-gu`,
	"bucketValue": `KpisTCU_bucketValue__QzJIh`,
	"bucketFooter": `KpisTCU_bucketFooter__W2hvy`,
	"bucketHealthy": `KpisTCU_bucketHealthy__b7x8h`,
	"bucketUnhealthy": `KpisTCU_bucketUnhealthy__WB8TM`
};
export default ___CSS_LOADER_EXPORT___;
